"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assets = void 0;
var common_1 = require("@timeflies/common");
var Assets;
(function (Assets) {
    Assets.spritesheets = {
        entities: '/static/spritesheets/spritesheet-entities.json'
    };
    var getMusicPathList = function (musicFolderName) { return ['ogg' /*, 'wav', 'mp3' */]
        .map(function (ext) { return "/static/audio/musics/" + musicFolderName + "/" + musicFolderName + "." + ext; }); };
    Assets.musics = {
        menu: [
            getMusicPathList('Ludum Dare 30 - Track 7'),
            getMusicPathList('Ludum Dare 28 - Track 3'),
        ],
        battle: [
            getMusicPathList('Ludum Dare 30 - Track 2'),
            getMusicPathList('Ludum Dare 30 - Track 9'),
        ]
    };
    var getSoundPathList = function (soundFolderName, filesNames) { return filesNames
        .map(function (fileName) { return ["/static/audio/sounds/" + soundFolderName + "/" + fileName + ".ogg"]; }); };
    Assets.sounds = {
        battleLose: getSoundPathList('battle-lose', ['negative']),
        battleWin: getSoundPathList('battle-win', ['sharp_echo']),
        buttonClick: getSoundPathList('button-click', ['click3']),
        characterAttackSword: getSoundPathList('character-attack-sword', ['swing', 'swing2', 'swing3']),
        characterHit: getSoundPathList('character-hit', ['HIT_SHORT_04', 'HIT_SLAP_07']),
        characterWalkNormal: getSoundPathList('character-walk-normal', common_1.ArrayUtils.range(5).map(function (i) { return "footstep_concrete_00" + i; })),
        characterWalkSlime: getSoundPathList('character-walk-slime', common_1.ArrayUtils.range(10).map(function (i) { return "slime" + (i + 1); })),
        error: getSoundPathList('error', ['error_001']),
        roomReady: getSoundPathList('room-ready', ['switch_003']),
        spellLaunch: getSoundPathList('spell-launch', ['drop_001']),
        spellLaunchDenied: getSoundPathList('spell-launch-denied', ['back_002']),
        spellLaunchInterrupt: getSoundPathList('spell-launch-interrupt', ['back_004']),
        turnEnd: getSoundPathList('turn-end', ['MENU B_Back']),
        turnStart: getSoundPathList('turn-start', ['MENU B_Select']),
    };
})(Assets = exports.Assets || (exports.Assets = {}));
